import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  className?: string
}

RequiredField.defaultProps = {
  className: '',
}

/**
 * shows an asterisk for required fields. Inherits all font-sizes.
 * @returns { *}
 */
function RequiredField(props: Props) {
  const { className } = props
  return <span className={classNames(style.wrapper, className)}> *</span>
}

export default RequiredField
